export default {
  Auth: {
    Cognito: {
      userPoolId: 'us-west-2_TdwId8jmC',
      userPoolClientId: '47fc92qk7ha5prar0ri4cn2vho',
      loginWith: {
        email: true,
      },
      signUpVerificationMethod: 'code' as const,
      mfaConfiguration: 'OFF' as const,
      passwordProtectionSettings: {
        passwordPolicyCharacters: ['requiresLowerCase', 'requiresUpperCase', 'requiresNumbers', 'requiresSymbols'],
        passwordPolicyMinLength: 8,
      },
    },
  },
};
